
// src/connects/user-favorites-panel.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import context from '../helpers/context'
import { emitAlertMessage } from '../actions/alert-message'
import map from 'lodash/map'
import find from 'lodash/find'
import filter from 'lodash/filter'
import each from 'lodash/each'

export const mapStateToProps = (state)=> {
  return {
    isFetching: state.favorite.isFetching,
    favorites: state.favorite.users,
    _groups: state.groups.items,
    current: state.user.current,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const groups = filter(stateProps._groups, (item)=> (!item.is_member && item.can_read) || item.favorite )

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    groups
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    favoriteGroup: (group, favorite)=> {
      dispatch(actions.updateFavoriteGroup(group.group_id, favorite))
      if (favorite)
        dispatch(emitAlertMessage({ message: 'label:お気に入りグループに追加しました', name: group.name }, 'success'))
      else
        dispatch(emitAlertMessage({ message: 'label:お気に入りグループから削除しました', name: group.name }, 'success'))
    },

    favoriteUser: (user, favorite)=> {
      dispatch(actions.updateFavoriteUser(user.user_id, favorite))
      dispatch(emitAlertMessage({ message: 'label:お気に入りユーザから削除しました', name: user.name }, 'success'))
    },

    setFavoriteUser: (users, props)=> {
      if (!users) return
      const unfavorites = filter(
        filter(users, (user) => user.user_id != props.current.user_id), // 自分以外のユーザのリストを作り、
        (user) => !find(props.favorites, (fav) => fav.user_id == user.user_id) // favoritesに含まれていないものを抽出
      )
      each(unfavorites, (user)=> {
          dispatch(actions.updateFavoriteUser(user.user_id, true))
      })
      if (unfavorites.length > 0) {
        var names = map(unfavorites, (user)=> user.name).join(', ')
        dispatch(emitAlertMessage({ message: 'label:お気に入りユーザに追加しました', name: names }, 'success'))
      }
      else {
        if (users.length == 1 && users.find(user => user.user_id == props.current.user_id)) {
          dispatch(emitAlertMessage('label:自身のフォローはできません', 'error'))
        }
        else {
          dispatch(emitAlertMessage('label:すでにフォロー設定済みです', 'success'))
        }
      }
    },

    willMount: ()=> dispatch(actions.fetchFavoriteUsers()),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  context({ showUserSelectionDialog: PropTypes.func }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-favorites-panel.js